export default __webpack_public_path__ + "static/media/revealed3.7ac4cd51.png";